import(/* webpackMode: "eager" */ "/home/ubuntu/shoptrendz/src/app/global-error.tsx");
